import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { createProjectSteps } from '../constants/createProjectSteps';

export function usePreviousProjectStep() {
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = useParams();

  const goToPreviousStep = () => {
    const currentIndex = createProjectSteps.findIndex(step =>
      location.pathname.includes(step.path)
    );

    if (currentIndex > 0) {
      const prevStep = createProjectSteps[currentIndex - 1];

      if (projectId === 'new' || !projectId) {
        navigate(`/projects/new/${prevStep.path}`);
      } else {
        navigate(`/projects/${projectId}/${prevStep.path}`);
      }
    } else {
      console.warn('You are already at the first step.');
    }
  };

  return { goToPreviousStep };
}
